import Row from './Row';
import { api } from '../../api/config'
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import WaitingLoader from '../general/loader/WaitingLoader';

export default function Canvas() {
    const [content, setContent] = useState([]);
    const [loading, setLoading] = useState(true);
    const { language } = useSelector((state) => state.language);

    function decodeHtmlEntities(str) {
        var doc = new DOMParser().parseFromString(str, 'text/html');
        return doc.documentElement.textContent;
    }

    const handlePage = () => {
        setLoading(true);
        api.post('/page/getPageContent', { language: language, url: window.location.pathname })
        .then(res => {
            if (res.data.success) { 
                const decodedData = decodeHtmlEntities(res?.data?.content);
                const jsonData = JSON.parse(decodedData);
                setContent(jsonData); 
            }
        })
        .finally(() => { 
            setLoading(false);
        })
    }

    useEffect(() => {
        handlePage();
        //eslint-disable-next-line
    }, [language, window.location.pathname]);

  
    
    return (
        !loading ?
        content.map((row) => ( <Row key={row.id} row={row} /> ))
        :
        <WaitingLoader />
    )
}